'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';

export function GoogleTagManager() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Only load GTM after user interaction or 3 seconds
    const events = ['scroll', 'mousedown', 'touchstart', 'keydown'];

    const handleInteraction = () => {
      setShouldLoad(true);
      events.forEach(event => {
        window.removeEventListener(event, handleInteraction);
      });
    };

    events.forEach(event => {
      window.addEventListener(event, handleInteraction, {
        passive: true,
        once: true
      });
    });

    // Fallback: Load after 3 seconds anyway
    const fallbackTimer = setTimeout(() => {
      handleInteraction();
    }, 3000);

    return () => {
      clearTimeout(fallbackTimer);
      events.forEach(event => {
        window.removeEventListener(event, handleInteraction);
      });
    };
  }, []);

  if (!shouldLoad) {
    return null;
  }

  return (
    <>
      <Script id="google-tag-manager" strategy="lazyOnload">
        {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5PDJS8');`}
      </Script>
    </>
  );
}
